// src/pages/Home.js
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import AOS from "aos";
import { FaTwitter, FaLinkedin, FaGithub } from "react-icons/fa";
import "aos/dist/aos.css";
import "./Home.css";
import TeacherMiniSection from "./TeacherMiniSection";

function Home() {
  const navigate = useNavigate();

  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  const isApp = navigator.userAgent.includes("BodhAIApp");
  if (isApp) {
    document.body.classList.add("app-view");
  }

  return (
    <>
    <div className="home-container">
      {/* ---------- HEADER ---------- */}
      <header className="home-header" data-aos="fade-down">
        <div className="logo">
          🧠 <span className="bold">Bodh</span><span className="accent">AI</span>
        </div>
        <nav className="home-nav">
          <button onClick={() => navigate("/login")}>Login / Register</button>
        </nav>
      </header>

      {/* ---------- HERO SECTION ---------- */}
      <section className="hero">
        <div className="hero-left" data-aos="fade-right">
          <h1>
            <mark>Sharpen</mark> Your Skills, <br />
            <mark>Practice</mark> With Purpose,<br />
            <mark>Crack</mark> the Future
          </h1>
          <p>
            BodhAI is your personalized practice space for MCQs and coding.
            Powered by AI. Built for learners, developers, and dreamers.
          </p>
            <div className="hero-cta-group">
              <button className="start-btn" onClick={() => navigate("/register")}>
                🚀 Get Started
              </button>
              <a
                href="https://www.producthunt.com/products/bodhai/launches/bodhai?embed=true&amp;utm_source=badge-featured&amp;utm_medium=badge&amp;utm_campaign=badge-bodhai"
                target="_blank"
                rel="noopener noreferrer"
                className="ph-hero-badge-link"
              >
                <img
                  src="https://api.producthunt.com/widgets/embed-image/v1/featured.svg?post_id=1180692&amp;theme=light&amp;t=1785003694826"
                  alt="BodhAI - Knowledge is the supreme wealth | Product Hunt"
                  width="250"
                  height="54"
                  className="ph-hero-badge-img"
                />
              </a>
            </div>
        </div>

        <div className="hero-right" data-aos="fade-left">
          <img src="/images/students.png" alt="Students working" />
        </div>
      </section>
      
      {/* ---------- FEATURE HIGHLIGHTS ---------- */}
      <section className="features">
        <div className="card" data-aos="fade-up" data-aos-delay="100">
          <h2>📝 Practice MCQs</h2>
          <p>Curated questions across Quant, Logic, Verbal, and Tech – with solutions.</p>
        </div>
        <div className="card" data-aos="fade-up" data-aos-delay="200">
          <h2>💻 Solve Coding Challenges</h2>
          <p>Attempt problems with built-in test cases & real-time feedback.</p>
        </div>
        <div className="card" data-aos="fade-up" data-aos-delay="300">
          <h2>📈 Analyze Your Growth</h2>
          <p>Get insights, topic-wise accuracy, and time management scores.</p>
        </div>
        <div className="card" data-aos="fade-up" data-aos-delay="400">
          <h2>🌐 AI-Generated Tests</h2>
          <p>Use our AI engine to generate topic-wise practice questions instantly.</p>
        </div>
      </section>

      {/* ---------- ABOUT SECTION ---------- */}
      <section className="about-bodhai" data-aos="zoom-in-up">
        <h2>
          Why Choose <span className="accent">BodhAI</span>?
        </h2>
        <ul>
          <li>✅ Smart tests curated by AI for targeted improvement.</li>
          <li>✅ Blend of technical and aptitude practice.</li>
          <li>✅ Clean analytics dashboard to track accuracy & speed.</li>
          <li>✅ Daily challenges & streak tracking for motivation.</li>
        </ul>
      </section>

      <br />

      {/* ---------- TEACHER SECTION ---------- */}
       <TeacherMiniSection />

      {/* ---------- INSPIRATIONAL QUOTE ---------- */}
      <section className="inspiration" data-aos="fade-up">
        <blockquote>
          <p>“विद्या धनं सर्वधनं प्रधानम्”</p>
          <cite>— Knowledge is the supreme wealth</cite>
        </blockquote>
      </section>

      {/* ---------- UPDATE LOG HIGHLIGHT ---------- */}
      <section className="update-log" data-aos="fade-up">
        <div className="update-card">
          <h2>🧾 What’s New in <span className="highlight">BodhAI</span>?</h2>
          <p>
            Explore new features, version upgrades, and under-the-hood improvements
            crafted to enhance your learning experience.
          </p>
          <a
            href="https://update.bodhai.pages.dev/"
            target="_blank"
            rel="noopener noreferrer"
            className="update-btn"
          >
            🔍 View Update Log
          </a>
        </div>
      </section>

      {/* ---------- FOOTER ---------- */}
      <footer className="home-footer">
        © {new Date().getFullYear()} BodhAI — Awakening through Knowledge |{" "}
        <span className="version">v1.2.0</span> 
        <br/>
        Last updated: {`${new Date().toLocaleString('default', { month: 'long' })} ${new Date().getFullYear()}`}
      </footer>
    </div>
 </>
  );
}

export default Home;
